<!-- Forgot UserName form -->

<div class="page-wrapper bg-gra-01 p-t-45 p-b-50">
    <div class="wrapper wrapper--w790">
        <div class="card card-5">
            <div class="card-heading">
                <h2 class="title">Forgot Username Form</h2>
            </div>
  
    <!-- ng if for forgot username -->
  
  
    <div style="border-radius: 10px;">
      <form
      #forgotUsernameForm="ngForm"
      (ngSubmit)="forgotUsernameForm.valid && onSubmit(forgotUsernameForm)"
      >
          <!-- starting card body -->
          <div class="card-body">
              <div class="alert" *ngIf="serverErrorMessages">
                  <span>{{serverErrorMessages}}</span>
              </div>
              <div class="alert" *ngIf="successMessage">
                  <span>{{successMessage}}</span>
              </div>
              <div class="form-row">
                  
                  <div class="name" style="font-weight: bolder; font-size:large;">EMAIL</div>
                  <div class="col-6">
                  <div class="value">
                      <div class="input-group">
                      <input class="input--style-5"
                        type="email"
                        #email="ngModel"
                        class="form-control"
                        (ngModel)="email"
                        name="email"
                        required
                        [ngClass]="{ 'invalid-textbox': forgotUsernameForm.submitted && !email.valid }"
                      />
                      <div *ngIf="forgotUsernameForm.submitted && email.errors">
                        <label *ngIf="email.errors.required" class="validation-message">
                        This field is required.
                        </label>
                      </div>
                      </div>
                  </div>
                  </div>
              </div>
              <div>
                  <input type="submit"class="btn btn-primary" style="padding:15px;" value="SEND USERNAME"/>
              </div>
  
  
          </div>
          <!-- end card body -->
  
      </form>
  
  </div>
  
  
  
  <!-- ng container for forgot username -->
  </div>
  </div>
  </div>
  